import React from 'react';
import AppLayout from '../components/AppLayout';
import OverviewList from '../components/OverviewList';
import {PageMenu,DeleteListItem,GenerateSpreadsheet,AddListItem,
        DownloadTemplate,DynamicListArea,BulkEdit,LoadGraphic,Step,
        Segment,SegmentComplete} from '../components/Common';
import {EditSizeLabel,EditableBox,EditableSelect,Box,Select,
        TextButton,Button,
        Input} from '../components/Input';
import u from '../utilities/Utilities';
import {Link} from 'react-router-dom';
import PropTypes, { number } from 'prop-types';
import {Spreadsheet} from '../data/Mimetypes';
import moment from 'moment';
import store from 'store';
import "../styles/enhanced-check-list.scss";

export default class EnhancedCheckOverrideList extends React.Component{

    settings={
        /**** Page Setup ****/
        title:"Enhanced Check Overrides",
        permission:"enhancedCheck",  //Accepts combined permission module as well
        url:"/enhanced-check-override-list",

        /**** Action Setup ****/
        addType:1,
        addURL:"/api/add-enhanced-check-override-entry",
        //templateURL:"/api/get-add-staff-template",
        //bulkURL:"/api/add-bulk-staff",
        deleteURL:"/api/delete-enhanced-check-override-entries",
        spreadsheetURL:"/api/generate-enhanced-check-override-spreadsheet",
        overviewURL:"/api/get-all-enhanced-check-overrides",

        /**** List Setup ****/
        list:true,
        listLabel:"enhanced-check-override-list",
        orderByField:"date",
        orderByType:"descending",
        numRows:20,
        checkboxPermissions:{},
        overview:undefined,
        onPopup:(content)=>{this.refs['layout'].onPopup(content)}
    };

    pageComponents={
        // check:{component:CheckTurnstile,props:{}},
        add:{component:AddEntry,props:{}},
        delete:{component:DeleteListItem,props:{}},
        spreadsheet:{component:GenerateSpreadsheet,props:{}}
    };

    state={
        selected:{
            tags:[],
            all:false,
            data:[],
            entryCount:0
        },
        pageMenuButtons:[],
        permissions:{},
    };

    componentDidMount=()=>{
        const permissions = u.getPermissions("enhancedCheck");

        this.setState({
            permissions:permissions,
            pageMenuButtons:[
                {label:"Add Entry", mobileLabel:"Add Entry",ref:"add",image:"/images/page-menu/add.png",title:"Add enhanced check override entry",enabled:permissions.update == 2},
                {label:"Delete",ref:"delete",mobileLabel:"Delete Entries",title:"Delete selected entries",enabled:(permissions.update==2)},
                {label:"Spreadsheet", mobileLabel:"Generate Spreadsheet",ref:"spreadsheet",image:"/images/page-menu/spreadsheet.png",title:"Generate spreadsheet from selection",enabled:permissions.view == 2},

            ],
        })
    };

    onSelectChange=(selected)=>{
        this.setState({selected:selected});
    };

    render=()=>{
        return (
            <AppLayout ref="layout" settings={this.settings}>

                <div className="page-error">{this.state.error}</div>

                <PageMenu buttons={this.state.pageMenuButtons}
                          settings={this.settings}
                          components={this.pageComponents}
                          selected={this.state.selected}/>

                <OverviewList  ref={(ref)=>{this.settings.overview=ref}}
                               settings={this.settings}
                               onSelectChange={this.onSelectChange}
                               registerReference={this.registerReference}
                               onMutatedChange={this.onMutatedChange}
                               location={this.props.location}
                               ignorePreviousTags={true}>
                    {
                        (content,index,onChange,onContentChange,registerRef)=>{
                            return (
                                <EnhancedCheckOverrideItem key={index} index={index} content={content} onChange={onChange} onContentChange={onContentChange} registerReference={registerRef} permissions={this.state.permissions}/>
                            )
                        }
                    }
                </OverviewList>

            </AppLayout>
        )
    }
}

class EnhancedCheckOverrideItem extends React.Component{
    state={
        loading:false,
        loadText:"",
        step:"view",
    }
    render=()=>{
        const content = this.props.content;

        return (
            <div style={{position:"relative",textAlign:"center"}}>
                <LoadGraphic active={this.state.loading} text={this.state.loadText}/>
                <Step active={this.state.step=="view"}>
                    <DynamicListArea listLabel={"enhanced-check-override-list"} permission="enhancedCheck" content={this.props.content} onChange={this.props.onChange} index={this.props.index}/>
                </Step>
                <Step active={this.state.step=="success"}>
                    <SegmentComplete onComplete={()=>{this.setState({step:"view"})}}>
                        <h2>Passback cleared successfully</h2>
                    </SegmentComplete>
                </Step>
            </div>
        )
    }
}

class AddEntry extends React.Component{

    state = {
        step: 'add',
        entryData:{},
        loading:false,
        loadText:"",
    }

    show=(show)=>{
        this.refs[this.props.reference].show(show);
    }

    onChange=(value,label,index,option)=>{
        let entryData=this.state.entryData;
        entryData[label] = value;
        this.setState({entryData:entryData});
    }

    onValidate=(fields)=>{
        this.setState({error:""});
        let keys = fields.map((item)=>{return item.field});
        let data = {};
        for(var i=0; i<keys.length; i++){
            if(this.refs[keys[i]]){
                const current = this.refs[keys[i]].validate();
                if(!current.valid){
                    this.setState({error:current.value});
                    return 0;
                }
                data[keys[i]] = current.value;
            }
        }
        //Additional validation
        if(moment(data.startTime).isSameOrAfter(data.endTime,"minute")){
            this.setState({error:"End time must be at least 1 minute after start time"});
            return 0;
        }

        this.refs[this.props.reference].onValidated(data);
    }

    render () {

        const {step, entryData} = this.state;
        const fields = [
            {label:"Date",dataType:"date",field:"date", rules:{required: true}},
            {label:"Start Time",dataType:"time",field:"startTime", rules:{required: true}},
            {label:"End Time",dataType:"time",field:"endTime", rules:{required: true}},
            {label:"A (per 1000)",info:'(No exit request on same day)',dataType:"box",field:"a_rate", type:'number', rules:{required: true, minValue:0,maxValue:1000}},
            {label:"B (per 1000)",info:' (Have exit request on same day)',dataType:"box",field:"b_rate", type:'number', rules:{required: true, minValue:0,maxValue:1000}},
        ]

        return (
            <AddListItem
                ref={this.props.reference}
                title={'Add Enhanced Check Override'}
                settings={this.props.settings}
                onComplete={this.onComplete}
                onRefreshList={this.props.onRefreshList}
                onToggleForm={this.props.onToggleForm}
            >
                <div className='segment-content'>
                    <LoadGraphic active={this.state.loading} text={this.state.loadText}/>
                    <Step active={step == 'add'}>
                        <h3>Complete the following</h3>
                        {
                            fields.map((item,index)=>{
                                return (
                                    <Input
                                        ref={item.field}
                                        key={index}
                                        fields={{
                                            ...item,
                                            ...{
                                                onChange: this.onChange,
                                            }
                                        }}
                                        content={entryData}
                                    />
                                )
                            })
                        }
                        <div className="segment-buttons">
                            <div className="segment-error">{this.state.error}</div>
                            {
                                (u.isMobileDevice())
                                    ?
                                    <Button onClick={this.onCancel}>Cancel</Button>
                                    :
                                    null
                            }
                            <Button onClick={()=>{this.onValidate(fields)}}>Confirm</Button>
                        </div>
                    </Step>
                </div>
            </AddListItem>
        )
    }
}